import { aboutImage, siteMeta, testimonials } from "@/mocks/site";
import Reveal from "@/pages/home/components/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

const principles = [
  { icon: "ri-focus-2-line", title: "只整理可复现的问题", desc: "描述具体、能被其他人复现的反馈才会进入档案。" },
  { icon: "ri-user-unfollow-line", title: "品牌名一律化名", desc: "站内品牌均为化名示例，不指向任何真实企业。" },
  { icon: "ri-scales-3-line", title: "不下绝对化结论", desc: "我们呈现争议与要点，判断权始终留给读者。" },
  { icon: "ri-refresh-line", title: "收到反馈就更新", desc: "条目会随新投稿与品牌方回应同步修订记录。" },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <SectionHeading
          eyebrow="ABOUT US"
          title={`关于${siteMeta.name}`}
          desc="我们不是裁判，只是一个把消费争议整理清楚的信息中转站。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <Reveal className="lg:col-span-5">
            <div className="h-72 w-full overflow-hidden rounded-lg border border-background-200 lg:h-[460px]">
              <img
                src={aboutImage}
                alt="避雷档案关于我们配图：堆叠的档案夹与索引卡"
                title={`关于${siteMeta.name}｜内容整理与原则`}
                className="h-full w-full object-cover object-top"
              />
            </div>
          </Reveal>

          <Reveal delay={100} className="lg:col-span-7">
            <div className="flex h-full flex-col">
              <p className="text-sm leading-relaxed text-foreground-700 md:text-base">{siteMeta.intro}</p>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                每天有大量消费体验散落在评论区、论坛和聊天记录里，很难被系统性地查阅。我们把它们收集、去重、按争议类型归档，
                让你在下单前能有几分钟时间，看清楚同类产品曾经在哪里出过问题。
              </p>

              <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {principles.map((item) => (
                  <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                    <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                      <i className={`${item.icon} text-xl leading-none`}></i>
                    </span>
                    <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950">{item.title}</h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal className="mt-14">
          <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
            <i className="ri-chat-quote-line text-xl leading-none text-primary-600"></i>
            用户这么说
          </h3>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
          {testimonials.map((item, index) => (
            <Reveal key={item.id} delay={index * 80}>
              <figure className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                <i className="ri-double-quotes-l text-2xl leading-none text-accent-400"></i>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{item.content}</blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                    {item.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block font-heading text-sm font-bold text-foreground-950">{item.name}</span>
                    <span className="block font-label text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}